import { Moment } from "moment";

export class TransactionFilterRequest {
    walletId?: number | null = null;
    keywords: string = "";
    amount: number | null = null;
    fromDate?: Moment | null = null;
    tillDate?: Moment | null = null;
    transactionType?: string | null = null;
    walletStatus?: string | null = null;
    transactionId: string = "";
    employeeStatus?: boolean | null = null;
    orderBy: string = "";
    asc: boolean = false;
    pageIndex: number = 0;
    userName?: string | null = null;
    constructor(id: number | null | undefined) {
        this.walletId = id;
    }
}

export class TransactionFilterResponse {
    total: number = 0;
    totalFilter: number = 0;
    hasNext: boolean = true;
    digitalWalletOwnerInfo: DigitalWalletOwnerInfoResponse = new DigitalWalletOwnerInfoResponse();
    rows: TransactionRowResult[] = [];
}

export class DigitalWalletOwnerInfoResponse {
    employeeId: number = 0;
    employeeName: string = "";
    employeeNumber: string = "";
    walletStatus: string = "";
    expiredDate: string = "";
    currencyId: number = 0;
    walletAmount: number = 0;
}

export class TransactionRowResult {
    id: number = 0;
    transactionType: string = "";
    transactionDate: string = "";
    transactionAmount: number = 0;
    connectedOrderId?: number = 0;
    employeeName: string = "";
    employeeNumber: string = "";
    employeeStatus: boolean = true;
    mobilePhone: string = "";
    currencyId: number = 0;
    docket: string = "";
    username: string = "";
    walletExpiryDate: string = "";
}
